import { render, staticRenderFns } from "./Chew.vue?vue&type=template&id=697747dd&scoped=true&"
import script from "./Chew.vue?vue&type=script&lang=js&"
export * from "./Chew.vue?vue&type=script&lang=js&"
import style0 from "./Chew.vue?vue&type=style&index=0&id=697747dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697747dd",
  null
  
)

export default component.exports